export default __webpack_public_path__ + "static/media/75.0032800d.jpg";